"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default={top:1,bottom:1,left:1,right:1};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tab-panel/lib/tabPositions.js
 ** module id = 738
 ** module chunks = 0
 **/